import { defineMessages } from 'react-intl';

export const practiceSeatUpgradeCardMessages = defineMessages({
  forCareTeams: {
    id: 'DHoBC/JGTC',
    defaultMessage: 'For care teams',
    description: 'Badge on the Practice plan card shown to Practice Standard teams',
  },
  practice: {
    id: 'g3MPWN94vz',
    defaultMessage: 'Practice',
    description: 'Plan name on the Practice plan card shown to Practice Standard teams',
  },
  yearlyOnly: {
    id: 'fY1q2f0r3M',
    defaultMessage: 'Yearly only',
    description: 'Pill on the Practice plan card saying the plan is only billed yearly',
  },
  standardSeat: {
    id: '4jb2no82PP',
    defaultMessage: '<strong>Standard seat:</strong> {price} user/month*',
    description:
      'Standard seat line on the Practice plan card. {price} is a formatted monthly price; the asterisk points at the sales tax footnote.',
  },
  standardSeatDescription: {
    id: 'yQKN1UyXkg',
    defaultMessage: 'Run the whole practice on Heidi',
    description: 'Supporting copy under the Standard seat line on the Practice plan card',
  },
  maxSeat: {
    id: 'eQiMKnkD1i',
    defaultMessage: '<strong>Max seat:</strong> {price} user/month*',
    description:
      'Max seat line on the Practice plan card. {price} is a formatted monthly price; the asterisk points at the sales tax footnote.',
  },
  maxSeatDescription: {
    id: '9MK8kZnJ2K',
    defaultMessage: 'For teams who use Agents daily',
    description: 'Supporting copy under the Max seat line on the Practice plan card',
  },
  getPractice: {
    id: 'Z/4jVasmaV',
    defaultMessage: 'Get Practice',
    description: 'Button on the Practice plan card that opens the seat checkout',
  },
  getPracticeMax: {
    id: 'RFBmyjbbUX',
    defaultMessage: 'Get Practice Max',
    description:
      'Button on the Practice plan card shown to a Practice Standard team; opens the seat checkout to move members to Max',
  },
  selectSeatsNextStep: {
    id: 'bj0+yORZ6l',
    defaultMessage: 'You’ll select seats in the next step',
    description: 'Caption under the Get Practice button on the Practice plan card',
  },
  standardSeatUnpriced: {
    id: '7WkkKH+1wr',
    defaultMessage: '<strong>Standard seat</strong>',
    description:
      'Standard seat line on the Practice plan card when a team member is requesting an upgrade, so no price is shown',
  },
  maxSeatUnpriced: {
    id: 'PRR0qcjVbd',
    defaultMessage: '<strong>Max seat</strong>',
    description:
      'Max seat line on the Practice plan card when a team member is requesting an upgrade, so no price is shown',
  },
  standardSeatRequestDescription: {
    id: 'NlTmipWBUH',
    defaultMessage: 'Try Agents to handle tasks',
    description:
      'Supporting copy under the Standard seat line on the Practice plan card when a team member is requesting an upgrade',
  },
  maxSeatRequestDescription: {
    id: 'b+W5oAzhLe',
    defaultMessage: 'More usage for Agents and Routines',
    description:
      'Supporting copy under the Max seat line on the Practice plan card when a team member is requesting an upgrade',
  },
  requestPractice: {
    id: 'DwkMd8FksQ',
    defaultMessage: 'Request Practice',
    description:
      'Button on the Practice plan card that moves a team member on to choosing the seat to request from their admins',
  },
  chooseSeatNextStep: {
    id: 'vrg/jk2Lig',
    defaultMessage: 'Choose the seat in the next step',
    description: 'Caption under the Request Practice button on the Practice plan card',
  },
  requestPracticeMax: {
    id: 'wvjnfiTScr',
    defaultMessage: 'Request Practice Max',
    description:
      'Button on the Practice plan card that moves a Practice Standard team member on to adding a note for their Max seat request',
  },
  addNoteNextStep: {
    id: 'Bq+lJV78t/',
    defaultMessage: 'Add optional note in the next step',
    description:
      'Caption under the Request Practice Max button on the Practice plan card shown to a Practice Standard team member',
  },
  currentSeat: {
    id: 'eBsxQczJxk',
    defaultMessage: 'Current',
    description:
      'Badge on the Standard seat line of the Practice plan card when a Practice Standard team member is requesting a Max seat',
  },
  everythingInPracticePlus: {
    id: 'kuwpLiRWHV',
    defaultMessage: 'Everything in Practice Standard, plus:',
    description: 'Lead-in above the Max seat feature list on the Practice plan card',
  },
  featureMaxUsage: {
    id: 'snPQxg3nvH',
    defaultMessage: 'Maximum usage allowance for agentic workflows',
    description: 'Max seat feature on the Practice plan card',
  },
  featureRegularAgenticUse: {
    id: 'Yq0T6NZuyZ',
    defaultMessage: 'Designed for regular agentic use',
    description: 'Max seat feature on the Practice plan card',
  },
  featureEarlyAccess: {
    id: 'qUBa6EkHLu',
    defaultMessage: 'Early access to advanced agentic features',
    description: 'Max seat feature on the Practice plan card',
  },
  everythingInScribeTeamPlus: {
    id: 't2JFDF0jI7',
    defaultMessage: 'Everything in Scribe Team, plus:',
    description:
      'Lead-in above the Practice feature list on the Practice plan card shown to Scribe Team teams',
  },
  everythingInClinicianMaxPlus: {
    id: 'j61vg7BupY',
    defaultMessage: 'Everything in Clinician Max, plus:',
    description:
      'Lead-in above the Practice feature list on the Practice plan card shown to Clinician Max teams',
  },
  featureEvidenceAnswers: {
    id: 'EzGKRufn3U',
    defaultMessage: 'Evidence answers in patient sessions',
    description: 'Practice feature on the Practice plan card shown to Scribe Team teams',
  },
  featureEvidenceSources: {
    id: 'Q1jWzg/jt3',
    defaultMessage: 'Choose your preferred Evidence sources',
    description: 'Practice feature on the Practice plan card shown to Scribe Team teams',
  },
  featureTryAgenticWorkflows: {
    id: 'hNpjn3/AzL',
    defaultMessage: 'Try agentic workflows',
    description:
      'Practice Standard feature on the Practice plan card and checkout summary',
  },
  featureDailyAgenticWorkflows: {
    id: 'yWnfkJFY+R',
    defaultMessage: 'Daily use of agentic workflows',
    description: 'Practice Max feature on the Practice plan card and checkout summary',
  },
  featureShareSessionsAndTemplates: {
    id: 'B7nhMcebi2',
    defaultMessage: 'Share sessions and templates across your team',
    description:
      'Practice feature on the Practice plan card shown to Clinician Max teams',
  },
  featureAddAssistantUsers: {
    id: '3wPm6Ia7fo',
    defaultMessage: 'Add assistant users at no extra cost',
    description:
      'Practice feature on the Practice plan card shown to Clinician Max teams',
  },
});
